// CoverageQueryHook.jsx
import { fetchBenefitByCode, fetchCoverages, fetchDeductibleOptions } from "hooks/CoverageHook";
import { useQuery } from 'react-query';

export const useCoverageQuery = (lang) => {
    return useQuery(['benefits', lang], () => fetchCoverages(lang), {
        onError: (error) => {
            console.error("Error fetching coverages:", error);
        },
    });
};

export const useBenefitByCode = (benefitCode, lang) => {
    return useQuery(['getBenefitByCode', benefitCode, lang], () => fetchBenefitByCode(benefitCode, lang), {
        enabled: Boolean(benefitCode && lang),
        onError: (error) => {
            console.error("Error fetching coverages:", error);
        },
    });
};

export const useDeductibleOptions = (isoNumber) => {
    return useQuery(['deductibleOptions', isoNumber ?? 'default'], () => fetchDeductibleOptions(isoNumber), {
        // null means "fetch default config from backend"; disabled only for initial state (country = 0)
        enabled: isoNumber !== 0 && isoNumber !== '0',
        onError: (error) => {
            console.error("Error fetching deductible options:", error);
        },
    });
};
